import type {MultiValue} from 'react-select';
import ReactSelect from 'react-select';

type Option = {
  value: string;
  label: string;
  key?: string;
};
type SelectProps = {
  id: string;
  name: string;
  options: Option[];
  onChange: (value: string) => void;
  value: string;
  className?: string;
  placeholder?: string;
  /** Test hook placed on the wrapping `<div>` (react-select owns its own DOM). */
  dataCy?: string;
};

const mapOptionsToString = (options: Option[] = []): string =>
  options
    ?.filter(Boolean)
    ?.map((item) => item?.value || '')
    ?.filter(Boolean)
    .join(',');

const mapStringToOptions = (options: string = ''): Option[] =>
  options
    ?.trim()
    ?.split(',')
    ?.filter(Boolean)
    ?.map((item) => ({
      value: item?.trim(),
      key: item?.trim(),
      label: item?.trim(),
    }));
export const Select = ({
  options,
  onChange,
  value,
  id,
  name,
  className,
  placeholder,
  dataCy,
}: SelectProps) => {
  return (
    <div className={className} data-cy={dataCy}>
      <ReactSelect
        classNames={{
          control: ({isFocused}) =>
            `border ${
              isFocused
                ? 'border-indigo-500 ring-1 ring-indigo-500'
                : 'border-gray-300'
            } dark:border-[#515355] dark:bg-transparent`,
          menu: () => 'dark:bg-[#1C1D20] border dark:border-[#515355]',
          option: ({isFocused}) =>
            `dark:text-gray-100 ${isFocused ? 'dark:bg-[#343538]' : ''}`,
          singleValue: () => 'dark:text-gray-100',
        }}
        isMulti
        options={options}
        onChange={(val: MultiValue<Option>) => {
          const value = mapOptionsToString(val as Option[]);
          onChange(value);
        }}
        value={mapStringToOptions(value)}
        id={id}
        name={name}
        placeholder={placeholder || '---Select One---'}
      />
    </div>
  );
};
